<!--
 * @Author: your name
 * @Date: 2021-11-18 22:24:21
 * @LastEditTime: 2021-11-19 14:59:19
 * @LastEditors: your name
 * @Description: 
-->
<template>
  <div class="user-center">
    <!--    <na-header class="header" />-->
    <div class="content-wrap">
      <user-tab />
      <div class="right-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import NaHeader from "../header/header";
import UserTab from "../user-tab/user-tab";

export default {
  name: "user-center-wrap",
  components: {
    NaHeader,
    UserTab,
  },
  props: {
    bgColor: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="scss">
.user-center {
  // min-height: 100vh;
  // overflow: hidden;
  padding-top: 72px;
  background-color: #f5f5f5;
  display: flex;
  .header {
    background-color: #fff;
  }

  .content-wrap {
    width: 14rem;
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    margin-top: 13px;
    margin-bottom: 23px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    overflow: hidden;

    .right-content {
      // width: 992px;
      flex: 1;
      border-radius: 4px;
      background-color: #fff;
      // overflow: hidden;
      // margin-left: 11px;
    }
  }

  @media only screen and (max-width: 1406px) {
    // .content-wrap {
    //   width: 1200px;
    // }
  }
}
</style>
